export default "__VITE_ASSET__oiDJXMQy__"